import { MapOption, MatchOption } from '@fox/import-core';
import { customAlphabet } from 'nanoid';
import React, { createContext, useContext, useState } from 'react';
import { ImportFinancialOptions, LinkedOrganisationDetails } from './contracts';
import { Link } from '../membership-form-template/contracts';

type ImporterContextValue = {
	batchId: string;
	linkedOrganisationDetails: LinkedOrganisationDetails;
	financialOptions: ImportFinancialOptions;
	matchOptions: MatchOption[];
	mapTypes: MapOption[];
	guideLineText?: string;
	reviewText?: string;
	error?: string;
	setError: (error: string) => void;
	redirectUrl?: Link;
};

const ImporterContext = createContext<ImporterContextValue | undefined>(undefined);
const PORTAL_IMPORT_PREFIX = 'import_portal_';
type ImporterContextProviderProps = {
	linkedOrganisationDetails: LinkedOrganisationDetails;
	financialOptions: ImportFinancialOptions;
	matchOptions: MatchOption[];
	mapTypes: MapOption[];
	guideLineText?: string;
	reviewText?: string;
	redirectUrl?: Link;
	children: React.ReactNode;
};

export const ImporterContextProvider: React.FC<ImporterContextProviderProps> = props => {
	const nanoid = customAlphabet('1234567890abcdefghijklmnopqrstuvwxyz', 10);
	const [batchId] = useState<string>(PORTAL_IMPORT_PREFIX + nanoid());
	const [error, setError] = useState<string | undefined>(undefined);

	const { financialOptions, linkedOrganisationDetails, mapTypes, matchOptions, guideLineText, reviewText, redirectUrl } = props;

	return (
		<ImporterContext.Provider
			value={{
				batchId,
				linkedOrganisationDetails,
				financialOptions,
				mapTypes,
				matchOptions,
				guideLineText,
				reviewText,
				error,
				setError,
				redirectUrl
			}}
		>
			{props.children}
		</ImporterContext.Provider>
	);
};

export const useImporterContext = () => useContext(ImporterContext);
